module.exports = __webpack_public_path__ + "img/note-text-purple.a16c2219.svg";